import { HOTELS_STATES } from '../app/app.state';
import { PUBLIC_STATES } from '../app-modules/public-landing/public.states';
import { CUSTOMER_FEEDBACK } from '../app-modules/customer-feedback/customer-feedback.states';
import { BILLING_STATES } from '../app-modules/billing-module/billing.states';

run.$inject = ['$location', '$uiRouter'];

/**
 * @param $location
 * @param $uiRouter
 */
export default function run($location, $uiRouter) {

    const host = $location.$$host;
    const domains = host.split('.');
    const subDomain = domains.length > 1 ? domains[0] : null;

    const $stateRegistry = $uiRouter.stateRegistry;

    const states = STATES[subDomain] || STATES.default;

    states.forEach(state => $stateRegistry.register(state));
}

const STATES = {
    pms: HOTELS_STATES.concat(CUSTOMER_FEEDBACK),
    billing: BILLING_STATES,
    default: PUBLIC_STATES,
};



// WEBPACK FOOTER //
// ./src/app-core/core.dynamic-routing.js